import { OneShipSocket } from './oneship-socket'

export * from './constants'
export * from './oneship-socket'
export * from './socket'
export default new OneShipSocket()
